import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const SoundIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1 3.99999C11.6 3.79999 10.9 3.89999 10.5 4.19999L6.5 8.59999H4.5C3.7 8.69999 3 9.39999 3 10.2V13.7C3 14.6 3.7 15.3 4.5 15.3H6.5L10.4 19.7L10.5 19.8C10.8 20 11.1 20.2 11.5 20.2C11.7 20.2 11.9 20.2 12.1 20.1C12.6 19.9 13 19.3 13 18.7V5.29999C13 4.69999 12.7 4.19999 12.1 3.99999ZM6 13.3H5V10.6H6V13.3ZM11 17.3L8 14V9.99999L11 6.59999V17.3ZM15.3 14.9C15.5 15.1 15.8 15.2 16 15.2C16.2 15.2 16.5 15.1 16.7 14.9C17.5 14.1 18 13.1 18 11.9C18 10.8 17.5 9.7 16.7 8.89999C16.3 8.49999 15.7 8.6 15.3 9C14.9 9.4 15 9.99999 15.4 10.4C15.8 10.8 16.1 11.3 16.1 11.9C16.1 12.5 15.9 13 15.4 13.4C14.9 13.9 14.9 14.5 15.3 14.9ZM15 5.99999C15.2 5.49999 15.8 5.19999 16.3 5.39999C19.1 6.39999 21 8.99999 21 12C21 15 19.1 17.6 16.3 18.6C16.2 18.7 16.1 18.7 16 18.7C15.6 18.7 15.2 18.4 15.1 18C14.9 17.5 15.2 16.9 15.7 16.7C17.7 16 19 14.1 19 12C19 9.89999 17.7 7.99999 15.6 7.29999C15.1 7.09999 14.8 6.49999 15 5.99999Z"
      />
    </Icon>
  );
};
